import { render, staticRenderFns } from "./PlanTaskGroupEditModal.vue?vue&type=template&id=653a4b10&"
import script from "./PlanTaskGroupEditModal.vue?vue&type=script&lang=ts&"
export * from "./PlanTaskGroupEditModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports